import { Injectable, OnInit, Output } from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";
import { EstatusJSON } from "../../shared/models/EstatusJSON";
import { LocationsAPIService } from "../../shared/services/API/LocationsAPI.service";
import { VirtualLocationsAPIService } from "../../shared/services/API/VirtualLocationsAPI.service";
@Injectable({
  providedIn: "root",
})
export class VirtualLocationsService implements OnInit {

  private isLoading: boolean = false;
  private isLoading$: Subject<boolean> = new Subject();
  
  constructor(private virtualLocationService: VirtualLocationsAPIService) {
  }

  ngOnInit() {
    
  }

  
  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


 
  getLocationCategoryChilds(parentIdentifier: string) {
    return this.virtualLocationService.getLocationCategoryChilds(parentIdentifier);
  }

  getChilds(parentIdentifier: string, idLocationCategoryChild: number):any{
    return this.virtualLocationService.getChilds(parentIdentifier, idLocationCategoryChild);
  }

  getChildrenFilteredByIdentifier(parentIdentifier, searchValue, childCategory){
    return this.virtualLocationService.getChildrenFilteredByIdentifier(parentIdentifier, searchValue, childCategory);
  }
}
